import React from 'react'
import { Link } from 'react-router-dom'
import { useDocumentTitle } from '../Hooks/useDocumentTitle'
import { t } from '../i18n'

export default function NotFound() {
  useDocumentTitle(t('notFound.title'))
  return (
    <div className="feed-message not-found">
      <h1>{t('notFound.title')}</h1>
      <Link to="/" className="btn btn-secondary">
        {t('notFound.home')}
      </Link>
    </div>
  )
}
